'use strict';

var _bindings;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaPayAmountPickerController = function () {
  function WinresOmalomaPayAmountPickerController($scope, $filter) {
    _classCallCheck(this, WinresOmalomaPayAmountPickerController);

    this.$scope = $scope;
    this.$filter = $filter;

    this.$scope.options = [];
    this.$scope.selected = null;
  }

  _createClass(WinresOmalomaPayAmountPickerController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$scope.$watchGroup([function () {
        return _this.unpaid;
      }, function () {
        return _this.passengers;
      }], function () {
        return _this.update();
      });
    }
  }, {
    key: 'update',
    value: function update() {
      var _this2 = this;

      var options = [];

      this.advance = 0;
      var min = 0;
      var max = this.unpaid;

      _.each(this.activeinvoices, function (activeinvoice) {
        if (activeinvoice.Type == "Advance") _this2.advance += activeinvoice.UnpaidAmount; // Count unpaid advances.
      });

      /*if(this.advance){
        options.push({
          //heading: 'custom',
          heading: 'Maksa ennakkomaksu',
          amount: this.advance
          });
          min = this.advance;
      }*/

      options.push({
        //heading: 'entire_amount',
        heading: this.$filter('i18next')('omaloma.payment.pay_entire_sum'),
        amount: this.unpaid
      });
      if (this.passengers && this.passengers.length > 0) {
        // TODO: Only count adults, as presumably kids don't pay their own trip.
        options.push({
          //heading: 'per_passenger',
          heading: this.$filter('i18next')('omaloma.payment.pay_by_passenger_count'),
          amount: this.unpaid / this.passengers.length
        });
      }

      var heading = "";

      var advance = this.advance;

      advance ? heading = this.$filter('i18next')('omaloma.payment.pay_advance_or_optional') : heading = this.$filter('i18next')('omaloma.payment.pay_optional');

      if (advance == 0) advance = this.unpaid; // advance use unpaid price by default if no advance.

      options.push({
        //heading: 'custom',
        heading: heading,
        //amount: this.unpaid / 2,
        amount: advance,
        range: { min: min, max: max }
      });

      this.$scope.options = options;
      if (options.length > 0) {
        this.select(0);
      }
    }
  }, {
    key: 'select',
    value: function select(index) {
      this.$scope.selected = index;
      this.onChange({ amount: this.$scope.options[index].amount });
    }
  }, {
    key: 'checkCustom',
    value: function checkCustom(index, option) {
      var _this3 = this;

      // If we edited a custom field that is currently active, note it as a change.

      /*var inStr = option.amount;
      var justOneDot = inStr.replace(/[.](?=.*?\.)/g, '');
      var outStr = parseFloat(justOneDot.replace(/[^0-9.]/g,'')).toFixed(2);
      option.amount = outStr;*/
      //this.inputField.validity.valid = false;

      if (option.amount > option.range.max) option.amount = option.range.max;else if (option.amount < option.range.min) option.amount = option.range.min;
      if (option.amount >= option.range.max) {
        if (!this.advanceTimer) {
          setAdvanceInvalid();
          this.advanceTimer = setTimeout(function () {
            return setAdvanceValid(_this3);
          }, 500); // Show red border for a while, then hide it.
        }
      }

      if (this.$scope.selected === index) {
        this.select(index);
      }
    }
  }]);

  return WinresOmalomaPayAmountPickerController;
}();

function setAdvanceInvalid() {
  var element = document.getElementById("advance-input");
  if (!element) return false;
  element.classList.add("ng-invalid");
  element.classList.add("ng-invalid-step");
  element.classList.remove("ng-valid");
  element.classList.remove("ng-valid-step");
  element.classList.remove("ng-valid-number");
  return true;
}

function setAdvanceValid(timerObject) {
  var element = document.getElementById("advance-input");
  if (!element) return false;
  element.classList.remove("ng-invalid");
  element.classList.remove("ng-invalid-step");
  element.classList.add("ng-valid-number");
  element.classList.add("ng-valid");
  element.classList.add("ng-valid-step");

  // Remove odd thin red border.
  element.style.borderRadius = "0px";
  element.style.outline = "6px solid rgb(18,73,138)";

  if (timerObject) timerObject.advanceTimer = null;

  return true;
}

// Check if payment tab is opened.
/*var advanceTimer = false;
jQuery('.q_tabs>.tabs-nav>li>a').on("click", function(){
  if(advanceTimer) return;
  advanceTimer = true;
  var checkAdvanceInput = (()=>{
    setTimeout(()=>{
      if(!setAdvanceValid()) // Disable invalid step validator.
        checkAdvanceInput(); // Loop till advance input is found.
      advanceTimer = false;
    }, 300);
  })();
  checkAdvanceInput();
});*/

WinresOmalomaPayAmountPickerController.$inject = ['$scope', '$filter'];

_module3.default.component('winresOmalomaPayAmountPicker', {
  template: require('./winresOmalomaPayAmountPicker.html'),
  controller: WinresOmalomaPayAmountPickerController,
  bindings: (_bindings = {
    activeinvoices: '<',
    unpaid: '<'
  }, _defineProperty(_bindings, 'activeinvoices', '<'), _defineProperty(_bindings, 'passengers', '<'), _defineProperty(_bindings, 'onChange', '&'), _bindings)
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaPayAmountPicker/winresOmalomaPayAmountPicker.js
// module id = 351
// module chunks = 2